module.exports = __webpack_public_path__ + "media/images/map/ligne16-8a6ca85b770ab527371c145d4c466b56.png";